import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Icon, Confirm, Button } from '.';

const AuthorizedDriversList = ({ data, onEditItem, onDeleteItem, readOnly }) => {

  if(data.length === 0){
    return (
      <div className="flex items-center justify-center text-sm text-info">
        <p>You can select 1(one) or multiple Authorized Drivers</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-2">
      {data.map(item => {

        return (
          <div className="border-2 border-gray-400 flex flex-col p-2 rounded" key={`authorizedDriversItem${item.id}`}>
            <div className="flex flex-1 flex-col xl:flex-row lg:flex-row">
              <div className="flex-col w-full space-y-1" >
                <div className="flex-1 flex space-x-1 items-center">
                  <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Name :</span>
                  <span className="flex-1 text-sm">{get(item, 'name')}</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex space-x-1 items-center">
              <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Address :</span>
              <span className="flex-1 text-sm">{get(item, 'address')}</span>
            </div>
            <div className="flex-1 flex space-x-1 items-center">
              <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Driver's License :</span>
              <span className="flex-1 text-sm">{get(item, 'license_number')}</span>
            </div>
            <div className="flex-1 flex space-x-1 items-center my-1">
              <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Expiry Date :</span>
              <span className="flex-1 text-sm">{moment(get(item, 'expiry_date')).format('MMM DD, YYYY')}</span>
            </div>
            {!readOnly &&
              <>
                <hr className="my-3 text-gray-300"/>
                <div className="flex items-center space-x-3">
                  <Button href="jsx-a11y/anchor-is-valid" 
                    onClick={onEditItem(item)}
                    className="!bg-transparent !w-auto inline-flex space-x-1 bg-white px-3 py-2 rounded border border-primary shadow">
                    <Icon.Pencil className="text-red-600"/>
                    <span className="text-sm text-primary">Edit</span>
                  </Button>
                  <Confirm 
                    value={item}
                    onConfirm={onDeleteItem}
                    message="Do you want to delete?"
                    buttonClassName="!bg-transparent inline-flex space-x-1 bg-white px-3 py-2 rounded border border-primary shadow">
                    <Icon.Trash className="text-red-600"/>
                    <span className="text-sm text-primary">Delete</span>
                  </Confirm>
                </div>
              </>
            }
          </div>
        )
      })}
    </div>
  )
}

AuthorizedDriversList.defaultProps = {
  data: [],
  onEditItem: undefined,
  onDeleteItem: undefined,
  readOnly: false
}

AuthorizedDriversList.propTypes = {
  data: PropTypes.instanceOf(Array),
  onEditItem: PropTypes.instanceOf(Function),
  onDeleteItem: PropTypes.instanceOf(Function),
  readOnly: PropTypes.bool
}

export default AuthorizedDriversList